/**
 * OVERRIDE Body.jsx
 * REASON: https://jugit.fz-juelich.de/fzj-internet/internet/-/issues/1033
 * When pointing the Video Block to an internal File, anonymous user would get an error message
 * that the video file could not be found.
 * Fixed in Volto 16.0.0, this is only a backport. This customization can be removed after upgrading to Volto >=16
 * FILE: https://github.com/plone/volto/blob/master/src/components/manage/Blocks/Video/Body.jsx
 * FILE VERSION: Volto 15.11.1
 * PULL REQUEST: https://github.com/plone/volto/pull/3363
 * TICKET: https://jugit.fz-juelich.de/fzj-internet/internet/-/issues/1033
 * DATE: 2022-01-30
 * DEVELOPER: @b.wolber / @iFlameing
 * CHANGELOG:
 *  - Fix the video block for anonymous user @iFlameing
 *
 * Every change is marked with a JSX comment at the beginning and end of the change:
 *
 *   START CUSTOMIZATION
 *   <CUSTOMIZATION>
 *   END CUSTOMIZATION
 */

/**
 * Body video block.
 * @module components/manage/Blocks/Video/Body
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {  Message } from 'semantic-ui-react';
import cx from 'classnames';
import { isInternalURL, flattenToAppURL } from '@plone/volto/helpers';
import PrivacyPolicyWrapper from 'volto-fzj-internet/components/PrivacyPolicy/PrivacyPolicy';


/**
 * Body video block class.
 * @class Body
 * @extends Component
 */
const Body = ({ data, isEditMode }) => {
  const ref = React.createRef();
  const onKeyDown = (e) => {
    if (e.nativeEvent.keyCode === 13) {
      ref.current.handleClick();
    }
  };
  const embedSettings = {
    icon: 'play',
    defaultActive: true,
    autoplay: false,
    aspectRatio: '16:9',
    tabIndex: 0,
    onKeyPress: onKeyDown,
    ref: ref,
  };
  let placeholder = data.preview_image
    ? isInternalURL(data.preview_image)
      ? `${flattenToAppURL(data.preview_image)}/@@images/image`
      : data.preview_image
    : null;

  let videoID = null;
  let listID = null;

  if (data.url) {
    if (data.url.match('youtu')) {
      if (data.url.match('list')) {
        listID = data.url.split('list=')[1].split('&')[0];
        embedSettings.url = `https://www.youtube.com/embed/videoseries?list=${listID}`
      } else {
        videoID = data.url.match(/.be\//)
          ? data.url.match(/^.*\.be\/(.*)/)[1]
          : data.url.match(/^.*\?v=(.*)$/)[1];
        embedSettings.source = "youtube"
        embedSettings.id = videoID
      }

    } else if (data.url.match('vimeo')) {
      videoID = data.url.match(/^.*\.com\/(.*)/)[1];
      embedSettings.source = "vimeo"
      embedSettings.id = videoID
   
    }
  }

  return (
    <>
      {data.url && (
        <div
          className={cx('video-inner', {
            'full-width': data.align === 'full',
          })}
        >
          {data.url.match('youtu') ? (
            <>
              {data.url.match('list') ? (
                  <PrivacyPolicyWrapper
                    placeholder={placeholder}
                    wrappingSettings={embedSettings}
                    service="youtube"/>
              ) : (
             
                  <PrivacyPolicyWrapper
                    placeholder={placeholder}
                    wrappingSettings={embedSettings}
                    service="youtube"/> 
              )}
            </>
          ) : (
            <>

              {data.url.match('vimeo') ? (
              
                  <PrivacyPolicyWrapper
                    placeholder={placeholder}
                    wrappingSettings={embedSettings}
                    service="vimeo"/>
              ) : (
                <>
                  {data.url.match('.mp4') ? (
                    // START CUSTOMIZATION
                    // eslint-disable-next-line jsx-a11y/media-has-caption
                    <video
                      src={
                        isInternalURL(data.url)
                          ? data.url.includes('@@download')
                            ? data.url
                            : `${flattenToAppURL(data.url)}/@@download/file`
                          : data.url
                      }
                      controls
                      poster={placeholder}
                      type="video/mp4"
                    />
                  ) : // END CUSTOMIZATION
                    isEditMode ? (
                      <div>
                        <Message>
                          <center>
                            <FormattedMessage
                              id="Please enter a valid URL by deleting the block and adding a new video block."
                              defaultMessage="Please enter a valid URL by deleting the block and adding a new video block."
                            />
                          </center>
                        </Message>
                      </div>
                    ) : (
                      <div className="invalidVideoFormat" />
                    )}
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
          * @static
          */
Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Body;
